import { ReactElement } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { Stack, Typography } from '@mui/material';
import { AlertContainedIcon, lightColorPalette } from '@linearb/linui-common';

interface Filter30daysTooltipProps {
  children: ReactElement;
}

export function Filter30daysTooltip({ children }: Filter30daysTooltipProps) {
  return (
    <Tooltip
      placement='top'
      title={
        <Stack gap={1} direction='row' padding='0.5rem' alignItems='start'>
          <AlertContainedIcon color={lightColorPalette.lbOrange_100} />
          <Typography lineHeight='1.4rem'>
            To highlight the most statistically significant results,
            <br />
            we suggest filtering for at least 30 days.
          </Typography>
        </Stack>
      }
    >
      <div>{children}</div>
    </Tooltip>
  );
}
